<template>
    <div>
      <Pos_sale_report/>
    </div>
  </template>
  
  <script>
  import Pos_sale_report from "@/components/adminArin/pos_system/pos/Pos_sale_report";
  export default {
    name: "PosSaleReport",
    components: {
      Pos_sale_report
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  